import React from 'react';
import PropTypes from 'prop-types';

const DynamicHeading = ({ hDepth, children }) => {
  // if the value of `hDepth` is less than 1, let it be equal to 1
  // or if the value of `hDepth` is more than 6, let it be equal to 6
  if (hDepth < 1) {
    hDepth = 1;
  } else if (hDepth > 6) {
    hDepth = 6;
  }
  const HeadingTag = `h${hDepth}`;
  return <HeadingTag>{children}</HeadingTag>;
};

DynamicHeading.propTypes = {
  /**
   * The number from 1 to 6 for headings
   */
  hDepth: PropTypes.number.isRequired,
  /**
   * The content of the component.
   */
  children: PropTypes.node,
};

export default DynamicHeading;
